import React from 'react';
import Typography from '@material-ui/core/Typography';

const Tutorial = () => {
	return (
		<div style={styles.container}>
			<Typography variant="h6" align="center">
				Click SEARCH to generate 10 random flights.
			</Typography>
			<Typography variant="h6" align="center">
				You can also filter them by: departure, arrival, minimum and maximum distance (default 5NM and 300NM)
			</Typography>
		</div>
	);
};

const styles = {
	container: {
		margin: '0 48px',
		color: 'gray'
	}
};

export default Tutorial;
